<template>
    <common-modal v-if="isOpen" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-patient-page-header
                :heading="$t('modals.patient_massege.title')"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-patient-page-header>
            <common-content-wrapper width="large">
                <patient-message-form @close="emitEvent({ name: 'close' })"></patient-message-form>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import PatientMessageForm from 'components/forms/patient/PatientMessageForm'
    export default {
        components: { PatientMessageForm },

        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>
